export default "/static/empty/no-transport.png"